import React from "react";
import { Avatar, Box, Card, Typography } from "@mui/material";

// โทนสีกลางของหน้า admin ทุกหน้า
export const GREEN = "#2e7d32";
export const GREEN_DARK = "#1b5e20";
export const LIGHT = "#f1f8e9";
export const BORDER = "#c5e1a5";

// ปุ่มหลัก (บันทึก) สีเขียว
export const primaryButtonSx = {
  px: 4,
  borderRadius: 3,
  width: { xs: "100%", sm: "auto" },
  bgcolor: GREEN,
  boxShadow: "0 4px 12px rgba(46,125,50,0.3)",
  "&:hover": { bgcolor: GREEN_DARK },
};

// ปุ่มเพิ่มรายการแบบเส้นประ
export const dashedButtonSx = {
  py: 1.2,
  borderRadius: 3,
  borderStyle: "dashed",
  borderColor: "#aed581",
  color: GREEN,
  "&:hover": { borderStyle: "dashed", borderColor: GREEN, bgcolor: LIGHT },
};

// กล่องย่อยสำหรับรายการที่ทำซ้ำได้ (ยานพาหนะ, ภาษา, รูป ฯลฯ) — ใช้กับ <Paper variant="outlined">
export const subCardSx = { p: 2.5, borderRadius: 3, borderColor: BORDER, bgcolor: "#fafdf7" };

export const SectionTitle = ({ step, title, extra }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
    {step != null && (
      <Avatar sx={{ width: 28, height: 28, fontSize: 14, fontWeight: 700, bgcolor: LIGHT, color: GREEN }}>{step}</Avatar>
    )}
    <Typography variant="subtitle1" fontWeight={700} color="text.primary">{title}</Typography>
    {extra}
  </Box>
);

// การ์ดหน้า admin: header ไล่เฉดเขียว + เนื้อหา + แถบปุ่มด้านล่าง (actions)
export function AdminPage({ icon, title, subtitle, actions, maxWidth = 860, children }) {
  return (
    <Box sx={{ minHeight: "100vh", p: { xs: 2, md: 4 } }}>
      <Card
        sx={{
          maxWidth,
          mx: "auto",
          mt: { xs: 2, md: 4 },
          borderRadius: 4,
          overflow: "hidden",
          boxShadow: "0 10px 30px rgba(46,125,50,0.15)",
        }}
      >
        <Box
          sx={{
            px: { xs: 3, md: 4 },
            py: 3,
            color: "white",
            background: `linear-gradient(135deg, ${GREEN} 0%, #43a047 100%)`,
            display: "flex",
            alignItems: "center",
            gap: 2,
          }}
        >
          {icon && <Avatar sx={{ bgcolor: "rgba(255,255,255,0.2)", width: 52, height: 52 }}>{icon}</Avatar>}
          <Box>
            <Typography variant="h5" fontWeight="bold">{title}</Typography>
            {subtitle && <Typography variant="body2" sx={{ opacity: 0.9 }}>{subtitle}</Typography>}
          </Box>
        </Box>

        <Box sx={{ p: { xs: 3, md: 4 } }}>{children}</Box>

        {actions && (
          <Box
            sx={{
              px: { xs: 3, md: 4 },
              py: 2.5,
              bgcolor: "#fafafa",
              borderTop: "1px solid #eee",
              display: "flex",
              justifyContent: "flex-end",
              gap: 1.5,
              flexWrap: "wrap",
            }}
          >
            {actions}
          </Box>
        )}
      </Card>
    </Box>
  );
}
